import { defineComponent as _defineComponent } from 'vue'
import { useForm } from '@/util/useForm';
import { watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'NewBieprivAddPrice',
  props: {
    visible: { type: Boolean },
    data: null
  },
  emits: ['change', 'close', 'submit'],
  setup(__props: any, { emit }) {

const props = __props as { visible: boolean; data: any[] };

const form = useForm();

watch(props, () => {
  if (props.data.length == 0) {
    emit('close');
  }
});

function deleteRow(id) {
  emit(
    'change',
    props.data.filter(item => item.id !== id)
  );
}
function submit() {
  if (props.data.every(item => item.new_price)) {
    emit('submit', props.data);
  }
}

return { __sfc: true,form, props, emit, deleteRow, submit }
}

})